import React, {useState} from "react";
import {Col, FormGroup, Input, Row} from "reactstrap";
import {every, isEmpty} from "lodash";
import {useSelector} from "react-redux";
import Select from "react-select";
import {
  getEditInventoryData,
  getSystemProfile,
} from "../../../../redux/Selectors/inventory.selector";
import {toast} from "react-toastify";

const INITIAL_LOCAL_STATE = {
  serial: "",
  check_code: "",
  profile: {},
};

const MANDATORY_KEYS = ["serial", "check_code", "profile"];

function BasicInformation(_props, ref) {
  const systemProfile = useSelector(getSystemProfile);
  const editInventoryData = useSelector(getEditInventoryData);
  const getEditData = editInventoryData ? editInventoryData : {};
  const {basicInfo = {}} = getEditData;

  const [inventoryFormObject, setInventoryFormObject] = useState(() =>
    !isEmpty(basicInfo) ? basicInfo : INITIAL_LOCAL_STATE
  );
  const [submitted, setSubmitted] = useState(false);

  const checkForValidation = () => {
    const validated = every(MANDATORY_KEYS, (each) => !!inventoryFormObject[each]);
    setSubmitted(true);
    if (!validated) {
      toast.error("Please check required fields");
    }
    return validated;
  };

  /* ## This Imperative Handle and customizes the instance value that is exposed to parent components when using ref. Please Don't Remove this Line ## */
  React.useImperativeHandle(ref, () => {
    return {
      isValidated: () => {
        return checkForValidation();
      },
      state: inventoryFormObject,
    };
  });

  const onChangeHandler = (e, type) => {
    if (type === 1) {
      setInventoryFormObject({
        ...inventoryFormObject,
        [e.target.name]: e.target.value,
      });
    } else {
      setInventoryFormObject({
        ...inventoryFormObject,
        selectedProfile: e,
        profile: e ? e.value : "",
      });
    }
  };

  const {serial, check_code, selectedProfile} = inventoryFormObject;

  return (
    <div className="pl-lg-4">
      <Row>
        <Col md="12">
          <FormGroup>
            <label className="form-control-label" htmlFor="input-serial">
              Serial <span className="text-red">*</span>
            </label>
            <Input
              className="form-control-alternative"
              id="input-serial"
              placeholder="Serial"
              type="text"
              value={serial}
              data-cy={"serial"}
              invalid={isEmpty(serial) && submitted}
              name="serial"
              onChange={(e) => onChangeHandler(e, 1)}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <FormGroup>
            <label className="form-control-label" htmlFor="input-check_code">
              Check Code <span className="text-red">*</span>
            </label>
            <Input
              className="form-control-alternative"
              id="input-check_code"
              placeholder="Check Code"
              type="text"
              value={check_code}
              invalid={isEmpty(check_code) && submitted}
              data-cy={"check_code"}
              name="check_code"
              onChange={(e) => onChangeHandler(e, 1)}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <FormGroup>
            <label className="form-control-label" htmlFor="profile">
              Profile <span className="text-red">*</span>
            </label>
            <Select
              closeMenuOnSelect={true}
              options={systemProfile}
              value={selectedProfile}
              classNamePrefix={"select_profile"}
              id={"select_profile"}
              placeholder={"Select Profile"}
              onChange={(e) => onChangeHandler(e, 2)}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
}

export default React.forwardRef(BasicInformation);
